export default "__VITE_ASSET__77c44103__"